import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col" }
const _hoisted_3 = { for: "email" }
const _hoisted_4 = { class: "p-field p-col" }
const _hoisted_5 = { for: "newPassword" }
const _hoisted_6 = { class: "p-field p-col" }
const _hoisted_7 = { for: "resetToken" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_9 = { class: "p-field p-col" }
const _hoisted_10 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_11 = { class: "p-field p-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.stateSubmitted === false)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "p-d-flex p-jc-center"
        }, {
          title: _withCtx(() => [
            _createVNode("h3", null, _toDisplayString(_ctx.$t('login.resetpw')), 1)
          ]),
          content: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('login.email')), 1),
                _createVNode(_component_InputText, {
                  id: "email",
                  type: "text",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('login.new_password')), 1),
                _createVNode(_component_InputText, {
                  type: "password",
                  id: "newPassword",
                  modelValue: _ctx.newPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newPassword = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('login.reset_token')), 1),
                _createVNode(_component_InputText, {
                  type: "text",
                  id: "resetToken",
                  modelValue: _ctx.resetToken,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetToken = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  onClick: _ctx.resetPwToken,
                  disabled: _ctx.fieldsEmpty,
                  style: {"width":"250px"},
                  label: _ctx.$t('login.reset')
                }, null, 8, ["onClick", "disabled", "label"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, { class: "p-d-flex p-jc-center" }, {
      content: _withCtx(() => [
        (_ctx.httpStatus === 200)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              severity: "success",
              closable: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.reset_success')), 1)
              ]),
              _: 1
            }))
          : (_ctx.httpStatus>0)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 1,
                severity: "error",
                closable: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('login.reset_error')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              class: "p-button-success",
              onClick: _ctx.toLogin,
              label: _ctx.$t('login.login')
            }, null, 8, ["onClick", "label"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}